import { CREATE_PRODUCT, GET_PRODUCTS, REMOVE_PRODUCT, UPDATE_PRODUCT } from '../actionTypes';

const initialState = { data: [], loaded: false, failed: false };

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {

        case GET_PRODUCTS.LOAD:
            return { ...state, loaded: false };
        case GET_PRODUCTS.SUCCESS:
            return { ...state, data: payload, loaded: true, failed: false };
        case GET_PRODUCTS.FAIL:
            return { ...state, loaded: true, failed: true };

        case CREATE_PRODUCT.LOAD:
            return { ...state, loaded: false };
        case CREATE_PRODUCT.SUCCESS:
            return { ...state, data: [...state.data, payload.data], loaded: true, failed: false };
        case CREATE_PRODUCT.FAIL:
            return { ...state, loaded: true, failed: true };

        case UPDATE_PRODUCT.LOAD:
            return { ...state, loaded: false };
        case UPDATE_PRODUCT.SUCCESS:
            return { ...state, data: state.data.map(it => it.id === payload.data.id ? payload.data : it), loaded: true, failed: false };
        case UPDATE_PRODUCT.FAIL:
            return { ...state, loaded: true, failed: true };

        case REMOVE_PRODUCT.LOAD:
            return { ...state, loaded: false };
        case REMOVE_PRODUCT.SUCCESS:
            return { ...state, data: state.data.filter(item => item.id !== payload.document), loaded: true, failed: false };
        case REMOVE_PRODUCT.FAIL:
            return { ...state, loaded: true, failed: true };
            
        default:
            return state;
    }
};